import { ReportType } from 'src/utils/constants/buro-reports';
import { CLEAR_BUREAU_REPORT_OPTIONS, CLEAR_BUREAU_REPORTS, LOAD_BUREAU_REPORTS, SAVE_BUREAU_REPORT_OPTIONS } from '../actions/bureauReportActions';


const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    reportType: ReportType.MONTHLY,
    page: 0
  },
  items: [],
  count: 0
};

const bureauReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_BUREAU_REPORTS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count
      };
    }
    case SAVE_BUREAU_REPORT_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_BUREAU_REPORT_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_BUREAU_REPORTS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default bureauReportReducer;
